import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentLinkCtrl implements IController {

  agent: AgentModel;
  agentReference: any;

}

angular
  .module('bringoz.admin.agents')
  .component('agentLink', {
    bindings: {
      agent: '<?',
      agentReference: '<?',
      agentId: '<?',
      agentName: '<?'
    },
    template: require('./agent-link.html').default,
    controller: AgentLinkCtrl
  });
